export default class JsonRpcReaderTransformer implements Transformer<string, string> {
  transform(chunk: string, controller: TransformStreamDefaultController<string>): void {
    let jsonData:
      {
        result?: any
        params?: any
      };

    try {
      jsonData = JSON.parse(chunk);
    } catch (e) {
      console.error('Erro ao fazer o parsing do JSON:', e);
      return;
    }

    if (!!jsonData.result?.status) {
      controller.enqueue(jsonData.result?.status)
    }

    if (!!jsonData.params) {
      controller.enqueue(jsonData.params)
    }

    if (jsonData.result === "ok") {
      controller.enqueue(jsonData.result);
    }
  }
}

